// BREACH ORIGIN
export const GET_BREACH_ORIGINS = '/breach-origin/query';
export const GET_BREACH_ORIGIN = '/breach-origin/';
export const POST_BREACH_ORIGIN = '/breach-origin/';
export const PUT_BREACH_ORIGIN = '/breach-origin/';
